import angular from 'angular';
import config from './attendances.config';

import {Attendances} from './attendances-by-group/attendances-by-group.component';
import {AttendancesByClass} from './attendances-by-class/attendances-by-class.component';
import {Timeline} from './timeline/timeline.component';
import {InvalidAttendances} from './invalid-attendances/invalid-attendances.component';
import {HistoryAttendances} from './history-attendances/history-attendances.component';

import AttendancesController from './attendances.controller';
import ViewAttendancesController from './view-attendances/view-attendances.controller';
import EditFullAttendanceController from './edit-full-attendance/edit-full-attendance.controller';

import './attendances.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.attendances', [])
  .component('attendancesComponent', Attendances)
  .component('attendancesByClassComponent', AttendancesByClass)
  .component('timelineComponent', Timeline)
  .component('invalidAttendancesComponent', InvalidAttendances)
  .component('historyAttendancesComponent', HistoryAttendances)
  .controller('AttendancesController', AttendancesController)
  .controller('ViewAttendancesController', ViewAttendancesController)
  .controller('EditFullAttendanceController', EditFullAttendanceController)
  .config(config)
  .name;
